import { Component, Input, OnInit } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { OrganizationConfigService } from '../../../../../../services/organization-config/organization-config.service';
import { CustomerPayment } from '../../../../../../models/customer';
import { PaymentService } from '../../../../../../services/payment/payment.service';

@Component({
  selector: 'app-refund-payment-modal',
  templateUrl: './refund-payment-modal.component.html',
  styleUrls: ['./refund-payment-modal.component.css']
})
export class RefundPaymentModalComponent {

  @Input() payment: CustomerPayment;
  @Input() successCallback: () => undefined;

  public isPartialRefund = false;
  public amount: number;

  public loading = false;

  public errorMessage = '';
  public serverError: number = null;

  constructor(
    public activeModal: NgbActiveModal,
    public orgConfig: OrganizationConfigService,
    private paymentService: PaymentService
  ) {}

  public onSubmit() {
    this.errorMessage = '';

    let submitPromise: Promise<void>;

    if (this.isPartialRefund) {
      if (!this.amount) {
        this.errorMessage = 'Select a refund amount.';
        return;
      }
      if (this.amount <= 0) {
        this.errorMessage = 'The refund amount must be a positive number.';
        return;
      }
      const unrefundedAmount = this.payment.amount - this.payment.amount_refunded;
      if (this.amount > unrefundedAmount) {
        this.errorMessage = 'The refund amount must no greater than ' + this.orgConfig.formatCurrency(unrefundedAmount);
        return;
      }
      submitPromise = this.paymentService.refundPayment(
        this.payment.id,
        this.amount
      );
    } else {
      submitPromise = this.paymentService.refundPayment(
        this.payment.id
      );
    }

    this.loading = true;

    submitPromise
      .then(() => {
        this.successCallback();
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to perform this refund.';
        } else if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loading = false; });
  }

}
